import { getEnv } from '@xbcb/ui-utils';
import { UiStage } from '@xbcb/ui-types';

const { stage } = getEnv();

export const isManageAnalysisBadgesEnabled = () => stage !== UiStage.PROD;
